import { ReactNode } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import queryClient from '@/lib/query-client'

interface QueryProviderProps {
  children: ReactNode
}

/**
 * Provider component for React Query
 * Wraps the application with QueryClientProvider
 */
export const QueryProvider = ({ children }: QueryProviderProps) => {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  )
}

export default QueryProvider
